export default {
  API_ENDPOINT: 'https://api-prod-us-east-1.pitchground.com/api',
};
